
import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import CurrentCurveChart from '../../tab1Inverter1/tab1Inverter1Chart/CurrentCurveChart';
import { Inverter1ChartApi, Inverter1Tab4Api } from '../../../../../../../api/Api';
import AppModal from "../../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";
import Tab4Inverter1 from '../Tab4Inverter1';
import Tab4Inverter1Log from './Tab4Inverter1Log';
import DownloadJpegButton from '../../../../../../../components/downloadJpegButton/DownloadJpegButton';


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD


    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}

function Tab4Inverter1Data({ ID, TabTitle }) {
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const chartRef = useRef();

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);



    // Fetch data dynamically based on updated StartDate, EndDate, and ID
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        // Generate credentials dynamically using current values
        const credentials = {
            LID: localStorage.getItem("LoginID"),
            LOC_CODE: localStorage.getItem("LCODE"),
            pass_key: "xyz",
            DT1: StartDate,
            DT2: EndDate,
            MTR_CODE: ID,
        };

        // console.log("Fetching data with credentials:", credentials);

        try {
            const res = await Inverter1Tab4Api(credentials);
            if (res?.DC_AC_KW_DATA && Array.isArray(res.DC_AC_KW_DATA)) {
                setLogData(res.DC_AC_KW_DATA);
            } else {
                setLogData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    // Re-fetch data whenever StartDate, EndDate, or ID changes
    useEffect(() => {
        fetchLogData();
    }, [ID, StartDate, EndDate]); // Add `ID` as a dependency

    // Handle Start Date change
    const handleStartDateChange = (value) => {
        setStartDate(value); // Update the StartDate directly
    };

    // Handle End Date change
    const handleEndDateChange = (value) => {
        setEndDate(value); // Update the EndDate directly
    };



    const chartDataVoltage = {
        labels: logData.map(item => item.DATETIME),
        datasets: [
            {
                label: 'DC_Power_KW',
                data: logData.map(item => parseFloat(item.DC_Power_KW) || 0),
                borderColor: 'red',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },
            {
                label: 'AC_POWER_KW',
                data: logData.map(item => parseFloat(item.AC_POWER_KW) || 0),
                borderColor: 'yellow',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },

        ],
    };




    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>

                <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
                    <Grid key="chart-grid" item xs={12}>
                        <Card>
                            <CardActions sx={{
                                display: "flex", // Enable flexbox
                                justifyContent: "space-between", // Align items to the right
                                alignItems: "center", // Center items vertically
                                gap: "16px", // Add some spacing between the inputs
                            }}>
                                <div style={{ marginLeft: "7px", fontSize: "14px" }}>DC Vs AC Power ({TabTitle})</div>
                                <div>
                                <label>
                                    From:&nbsp;
                                    <input
                                        type="date"
                                        value={StartDate} // Use StartDate directly
                                        onChange={(e) => handleStartDateChange(e.target.value)}
                                        style={{
                                            padding: "2px 2px",
                                            borderRadius: "14px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </label>
                                <label>
                                    To:&nbsp;
                                    <input
                                        type="date"
                                        value={EndDate} // Use EndDate directly
                                        onChange={(e) => handleEndDateChange(e.target.value)}
                                        style={{
                                            padding: "2px 2px",
                                            borderRadius: "14px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </label>
                                &nbsp;<DownloadJpegButton targetRef={chartRef} fileName={`DC Vs AC Power_${TabTitle}.jpeg`} />
                                </div>
                               

                                {/* <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button> */}
                               
                            </CardActions>
                        </Card>
                    </Grid>


                </Grid>

                <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 2 }}>

                    <Grid ref={chartRef} key="chart-grid" item xs={6}>
                        <Card>
                            <CardActions>
                                {/* Pass the 'data' prop correctly */}
                                <CurrentCurveChart data={chartDataVoltage} name={""} />


                                {/* <InvverterFullSize title={""} onFullScreen={handleOpenMix} />
                                <CurrentCurveChart data={chartDataVoltage} name={"Voltage Curve"} />
                            <AppModal open={OpenMix} handleClose={handleCloseMix}>
                            <CurrentCurveChart data={chartDataVoltage} name={"Voltage Curve"} />
                            </AppModal> */}

                            </CardActions>
                        </Card>
                    </Grid>

                    <Grid key="chart-grid" item xs={6}>
                        <Card>
                            {/* <CardActions>

                            <Tab4Inverter1Log  TabTitle={TabTitle} ID={ID}/>
                            </CardActions> */}
                            <Tab4Inverter1Log TabTitle={TabTitle} ID={ID} Dt1={StartDate} Dt2={EndDate} />
                        </Card>
                    </Grid>

                </Grid>






            </Box>
        </>
    );
}

export default Tab4Inverter1Data;